import * as S from './style';
import * as T from '../../Typography';
import Image from '../../Image';
import Icon from '../../Icon';
import { dateFormatter } from '../../../helpers';
import { userStatuses } from '../../../constants';

const Link = ({
  to,
  title,
  variant,
  m,
  children,
  programme,
  client,
  borderColor,
  customText,
}) => {
  switch (variant) {
    case 'graphic1':
      return (
        <S.Link to={to}>
          <S.GraphicWrapper {...m}>
            <S.Title>
              <T.P weight="light" mr="1">
                {customText || 'My'}
              </T.P>
              <T.P weight="bold">{title}</T.P>
            </S.Title>
            <Image
              image="logoUpPurple"
              style={{ position: 'absolute', bottom: '0', right: '0' }}
              alt="circles"
            />
            <Image
              image="logoDownPurple"
              style={{ position: 'absolute', bottom: '0', left: '0' }}
              alt="circles"
            />
          </S.GraphicWrapper>
        </S.Link>
      );
    case 'graphic2':
      return (
        <S.Link to={to}>
          <S.GraphicWrapper {...m}>
            <S.Title>
              <T.P weight="light" mr="1">
                {customText || 'My'}
              </T.P>
              <T.P weight="bold">{title}</T.P>
            </S.Title>
            <Image
              image="logoUpOrange"
              style={{ position: 'absolute', top: '0', right: '0' }}
              alt="circles"
            />
            <Image
              image="logoDownOrange"
              style={{ position: 'absolute', bottom: '0', left: '0' }}
              alt="circles"
            />
          </S.GraphicWrapper>
        </S.Link>
      );
    case 'graphic3':
      return (
        <S.Link to={to}>
          <S.GraphicWrapper {...m}>
            <S.Title>
              <T.P weight="light" mr="1">
                Client
              </T.P>
              <T.P weight="bold">{title}</T.P>
            </S.Title>
            <Image
              image="logoUpGreen"
              style={{ position: 'absolute', top: '0', right: '0' }}
              alt="circles"
            />
            <Image
              image="logoDownGreen"
              style={{ position: 'absolute', bottom: '0', left: '0' }}
              alt="circles"
            />
          </S.GraphicWrapper>
        </S.Link>
      );
    case 'programme':
      return (
        <S.Link to={to}>
          <S.Wrapper {...m} borderColor={borderColor}>
            <Icon icon="programme" width="40px" height="40px" mr="4" />
            <S.ProgDetails>
              <T.P color="gray8" caps>
                {programme?.date ? dateFormatter(programme.date) : 'N/A'}
              </T.P>
              <T.P weight="bold" mr="1">
                {programme?.title || 'Home Programme'}
              </T.P>
            </S.ProgDetails>
          </S.Wrapper>
        </S.Link>
      );
    case 'client':
      return (
        <S.Link to={to}>
          <S.Wrapper {...m} borderColor={borderColor}>
            {client ? (
              <T.P weight="light" mr="1">
                {client.status === userStatuses.DELETED ? (
                  'Discharged Client'
                ) : (
                  <>
                    <span style={{ fontWeight: 'bold' }}>
                      {client.firstInitial}
                    </span>{' '}
                    {client.lastInitial} {client.postcode}
                  </>
                )}
              </T.P>
            ) : (
              <T.P weight="light">N/A</T.P>
            )}
          </S.Wrapper>
        </S.Link>
      );
    default:
      return (
        <S.Link to={to}>
          <S.Wrapper {...m}>{children}</S.Wrapper>
        </S.Link>
      );
  }
};

export default Link;
